import { UIComponentCSSStyleImpl, UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';

export interface RepeatCardSettingCSSStyle extends UIComponentCSSStyle
{
    getInnerWrapperCSSStyle(isSelected:boolean):object;
    getTitleLabelCSSStyle(isSelected:boolean):object;
}

export class RepeatCardSettingCSSStyleImpl extends UIComponentCSSStyleImpl implements RepeatCardSettingCSSStyle
{
    getInnerWrapperCSSStyle(isSelected:boolean):object
    {
        return{
            display:'flex',
            boxSizing:'border-box', 
            textAlign:'center', 
            border:isSelected?'':'1px solid #EFEFEF', 
            borderRadius:'4px', 
            cursor: "pointer",
            boxShadow:"0 5px 10px 0 rgba(0,0,0,0.05)", 
            backgroundColor:isSelected?'#003187':'#FFFFFF',
            marginBottom:"10px"
        };
    }
    
  
    getTitleLabelCSSStyle(isSelected:boolean):object
    {
        return{
            marginTop:'11px',
            textAlign:'center', 
            height:"20px", 
            cursor: "pointer",
            color:isSelected?'#FFFFFF':'#999999', 
            letterSpacing:"0", 
            lineHeight:'20px',
            fontSize:'12px', 
            fontWeight:900
        };
    }
}    


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/repeatcardsetting/repeatcardsettingcss.tsx